module.exports = "https://payments.pagoefectivo-pre.com/Muli-Regular.ea2276b94ec317138dd46cb2449131c5.woff";